export default __webpack_public_path__ + "static/trevor2-69c597e5cf6b2c30b1b84ea3a1ae2e05.jpg";